import { FaDiamond } from "react-icons/fa6";

export const aboutUsContent = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <h2 className="about-us-heading">History</h2>
      <p>
        Founded in 2012, R K Pareek & Co. has grown to become a trusted and
        respected provider of comprehensive auditing, taxation, accounting,
        financial advisory and consultancy services. We are dedicated to guiding
        our clients through the complexities of the financial world with
        expertise, integrity, and a commitment to excellence. Our firm prides
        itself on delivering customized solutions that address the unique
        challenges and opportunities of each client.
      </p>
      <h2 className="about-us-heading">Vision & Mission</h2>
      <p>
        <span className="diamond-icon">
          <span className="diamond-icon">
            <FaDiamond />
          </span>
        </span>
        <b>Vision: </b> To be the leading provider of innovative and reliable
        financial solutions, empowering our clients to achieve their financial
        aspirations with confidence.
      </p>
      <p>
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        <b>Mission: </b> To offer unparalleled auditing, financial and advisory
        services by combining deep industry knowledge, advanced technology and a
        client-focused approach, ensuring the success and satisfaction of our
        clients.
      </p>
      <h2 className="about-us-heading">Our Values</h2>
      <p>
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        <b>Integrity:</b> We adhere to the highest ethical standards, ensuring
        honesty and transparency in all our dealings.
      </p>
      <p>
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        <b>Excellence:</b> We pursue excellence in every task, striving to
        deliver superior services and outcomes.
      </p>
      <p>
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        <b>Client-Centric:</b> Our clients' needs and goals are at the heart of
        everything we do.
      </p>
      <p>
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        <b>Innovation:</b> We embrace innovation to stay ahead in a rapidly
        changing financial landscape.
      </p>
      <p>
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        <b>Collaboration:</b> We believe in the power of teamwork and work
        collaboratively to achieve the best results for our clients.
      </p>
      <h2 className="about-us-heading">Our Commitment</h2>
      <p>
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        Proactively understand requirements & provide concrete resolutions
        distinguishing client ethos, background & restrictions.
      </p>
      <p>
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        Customized client service ensuring timely & quality deliverables.
      </p>
      <p>
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        Distinctive service parameters having domain experience & expertise.
      </p>{" "}
      <p>
        {" "}
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        Growth approach.
      </p>
    </div>
  );
};
